import {
  capitalizeEachFirstLetter,
  decamelize,
  formatCurrency,
  getOrderingParam,
} from "../../utils";

import type { GetExpertContributorsParams } from "./types";

export const isManualReward = (
  rewardType: EnumType<typeof ENUMS.RewardRuleContentType>,
) => rewardType === ENUMS.RewardRuleContentType.ManualRewardType;

export const getRewardType = (
  rewardType: EnumType<typeof ENUMS.RewardRuleContentType>,
) => {
  return capitalizeEachFirstLetter(
    decamelize(rewardType.replace("RewardType", ""), " "),
  );
};

export const getRewardCap = (value: number | null) => {
  if (!Number(value)) {
    return "No Limit";
  }

  if (!value) return "";

  return formatCurrency(value);
};

// values are sent comma separated, so commas inside a single value must be dropped
const joinMultiValueParam = (values: string[] | undefined) => {
  const cleaned = (values ?? [])
    .map((value) => value.replaceAll(",", "").trim())
    .filter(Boolean);

  return cleaned.length ? cleaned.join(",") : undefined;
};

export const parseExpertContributorsParams = (
  params: GetExpertContributorsParams | void,
) => {
  const {
    order_by,
    order_dir,
    location,
    skills,
    education,
    job_titles,
    companies,
    idv_status,
    ...rest
  } = params ?? {};

  const ordering = getOrderingParam({ order_by, order_dir });

  return {
    ...rest,
    location: joinMultiValueParam(location),
    skills: joinMultiValueParam(skills),
    education: joinMultiValueParam(education),
    job_titles: joinMultiValueParam(job_titles),
    companies: joinMultiValueParam(companies),
    idv_status: joinMultiValueParam(idv_status),
    ordering,
  };
};
